import { getString } from 'firebase/remote-config';
import { useEffect, useMemo, useState } from 'react';

import { isProd } from 'helpers/utils';

import { getAbAutoTestsParams } from '../helpers';
import { activationConfigPromise, remoteConfig } from '../initFirebase/initFirebase';
import { STAGE_EXPERIMENT_KEY } from '../utils/const';
import { Experiment } from '../utils/experiments';

const useVariant = (key: Experiment | string): string => {
    const { variantName } = useMemo(() => getAbAutoTestsParams(), []);
    const envBasedKey = isProd() ? key : `${key}_${STAGE_EXPERIMENT_KEY}`;

    const preloadedValue = remoteConfig && key ? getString(remoteConfig, envBasedKey) : '';

    const [variant, setVariant] = useState<string>(() => variantName || preloadedValue || '');

    useEffect(() => {
        if (!key || variantName || preloadedValue) return;

        activationConfigPromise.then(() => {
            const remoteVariant = getString(remoteConfig, envBasedKey);

            setVariant(remoteVariant);
        });
    }, [envBasedKey, variantName, preloadedValue]);

    return variant;
};

export default useVariant;
